<div class="topHead">
    <a href="javascript:void(0);" *ngIf="tab != 3" class="adminBack" [routerLink]="['/authoring_list']"[queryParams]="{tab: tab}"><img src="assets/images/admin/backarrow.png" /> Back to Content Authoring</a>
    <a href="javascript:void(0);" *ngIf="tab == 3" class="adminBack" [routerLink]="['/authoring_create']"[queryParams]="{id:content_capsule_id,tab: tab}"><img src="assets/images/admin/backarrow.png" /> Back to Content Authoring</a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>

<div class="formHeading pr-0">
    <div class="row m-0">
        <div class="col-12 col-md-6">
    <h2>View Content Capsule</h2>
    
    <p>{{contentDetailsData?.capsule_name}}</p> 
    <!-- that is staticb crate the daynamic  -->
</div>
    </div>
</div>

<div class="sttperWrap pt-1 mb-4 contentData">
    <div class="sttperBody sttperContentBody mt-5">
        <div class="row m-0">
            <!-- <h4>{{contentDetailsData?.capsule_name}}</h4>  -->
            <ul class="modifyIcons">
                <li *ngIf="contentDetailsData?.assessment_id && contentDetailsData.assessment_id!=null && contentDetailsData.assessment_id!=''"><a href="javascript:void(0);"><img src="assets/images/icons/frame.svg"></a></li>
                <li *ngIf="(contentDetailsData?.contentCapsuleMedia) && (getMediaType(contentDetailsData.contentCapsuleMedia,'1')==true)"><a href="javascript:void(0);"><img src="assets/images/icons/text.svg"></a></li>
                <li *ngIf="(contentDetailsData?.contentCapsuleMedia) && (getMediaType(contentDetailsData.contentCapsuleMedia,'2')==true)"><a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg"></a></li>
                <li *ngIf="(contentDetailsData?.contentCapsuleMedia) && (getMediaType(contentDetailsData.contentCapsuleMedia,'3')==true)"><a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg"></a></li>
            </ul>
        </div>
        <!-- <div *ngIf="(contentDetailsData?.contentCapsuleMedia)">
            <div *ngFor="let media of contentDetailsData.contentCapsuleMedia; let i = index">
                <h4 *ngIf="(media.media_type==2 || media.media_type==3)">{{media.media_title}}</h4>
                <p class="pt-3" *ngIf="(media.media_type==1 || media.media_type==2 || media.media_type==3)" [innerHtml]='media.media_content'></p>
                <div class="videoUrlWrap" *ngIf="(media.media_type==3)">
                    <video controls >
                        <source src="{{media.media_path}}" type="video/mp4">
                        Sorry, your browser doesn't support embedded videos.
                    </video>
                </div>
                <div class="videoImgWrap mt-4 mb-4"  *ngIf="(media.media_type==2)">
                    <img src="{{media.media_path}}">
                </div>
                <hr/>
            </div>
        </div>   -->
        <div class="dynamicBookWrap">
            <div class="dynamicPlugin p-0">
                <mat-horizontal-stepper #stepper [@.disabled]="true"  selectedIndex="0">
                    <mat-step *ngFor="let subValues of contentDetailsDatas; let j = index">
                        <div class="stepperCenter">
                            <div class="container">
                                <div class="row">
                                    <div class="viverContent" *ngIf="subValues.media_type==1">
                                        <div class="viverContentList">
                                            <h4 *ngIf="(subValues.media_type==2 || subValues.media_type==3)">
                                                {{subValues.media_title}}</h4>
                                            <p class="pt-3" [innerHtml]='subValues.media_content'></p>
                                        </div>
                                    </div>
                                    <div class="col-lg-12" *ngIf="subValues.media_title !='' && subValues.media_type==2"><h4 >{{subValues?.media_title}}</h4></div>
                                    <div class="viverContent" *ngIf="subValues.media_type==2">
                                       
                                        <div class="viverContentList" *ngIf="subValues.media_content !=''">
                                            <p class="pt-3" *ngIf="subValues.media_content !=''"
                                                [innerHtml]='subValues?.media_content'></p>
                                        </div>
                                        <div class="viverContentList" *ngIf="subValues.media_path">
                                            <div class="imageWrap">
                                                <img src={{subValues.media_path}}>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12" *ngIf="subValues.media_title !='' && subValues.media_type==3"><h4 >{{subValues?.media_title}}</h4></div>
                                    <div class="viverContent" *ngIf="subValues.media_type==3">
                                        <div class="viverContentList" *ngIf="subValues.media_content !=''">
                                            <p class="pt-3" *ngIf="subValues.media_content !=''" [innerHtml]='subValues.media_content'></p>
                                        </div>
                                        <div class="viverContentList" *ngIf="subValues.media_path !=''">
                                            <div class="imageWrap">
                                                <!-- <video controls>
                                                    <source src={{subValues.media_path}} type="video/mp4">
                                                    Sorry, your browser doesn't support embedded videos.
                                                </video> -->
                                                <video fireVideo src={{subValues.media_path} controls="true" muted width="400" controlsList="nodownload" oncontextmenu="return false;">
                                                    Sorry, your browser doesn't support embedded videos.
                                                </video>
        
                                            </div>
                                        </div>
                                    </div>
                                    <button mat-button matStepperPrevious *ngIf="j !=0"> <img
                                            src="assets/images/icons/preview-arrow.png" /> Previous</button>
                                    <button mat-button matStepperNext
                                        *ngIf="contentDetailsData.contentCapsuleMedia.length-1 != j" >Next<img
                                            src="assets/images/icons/next-arrow.png" /></button>
                                            
                                    <!-- <button mat-button matStepperNext
                                        *ngIf="capsuleData.subModules.media_data.length-1 == j && capsuleData.subModules.assessment_id == null"
                                        (click)="finishSubModule(view)">Finish Sub Module</button> -->
                                    <!-- <button mat-button matStepperNext
                                        *ngIf="view==1 && capsuleData.subModules.media_data.length-1 ==j" (click)="finishSubModule(view)">Finish Sub Module</button> -->
                                    <!-- <button class="btn btn-primary takeass"
                                        *ngIf="capsuleData.subModules.media_data.length-1 ==j && view !=1 && view !=2  && capsuleData.subModules.assessment_id != null"
                                         (click)="goToAssessment()">Take Assessments</button> -->
                                         <!-- <button class="btn btn-primary takeass"
                                         *ngIf="capsuleData.subModules.media_data.length-1 ==j && capsuleData.subModules.assessment_id != null"
                                          (click)="goToAssessment()">Take Assessments</button> -->
                                    <div class="pagecountNumber"><b class="">{{j+1}}</b>/<b
                                            class="">{{contentDetailsData.contentCapsuleMedia.length}}</b>
                                            <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-1 mr-1" *ngIf="contentDetailsData?.assessment_id && contentDetailsData.assessment_id!=null && contentDetailsData.assessment_id!=''" [routerLink]="['/authoring_assessment_view']"
                                            [queryParams]="{id:contentDetailsData.assessment_id,capsuleId:contentDetailsData.content_capsule_id,backLink:'authoring_view',tab:tab}"><span>View assessment</span></a> </div>
                                </div>
                            </div>
                        </div>
                    </mat-step>
                </mat-horizontal-stepper>
                <div class="pagiMainWrap">
                    <div class="container">
                        <div class="row">
                            <div class="pagiWrap">
                                <div class="pagecount "><b class="d-none">1</b><b class="d-none">5</b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="sttperFooter" *ngIf="contentDetailsData?.assessment_id && contentDetailsData.assessment_id!=null && contentDetailsData.assessment_id!=''">
        <div class="row m-0">
            <div class="m-auto">
                <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-1 mr-1" [routerLink]="['/authoring_assessment_view']"
                [queryParams]="{id:contentDetailsData.assessment_id,capsuleId:contentDetailsData.content_capsule_id,backLink:'authoring_view',tab:tab}"><span>View assessment</span></a>
            </div>
        </div>
    </div> -->
</div>

<ngx-spinner><p style="color: white" > Loading... </p></ngx-spinner>

